import React from 'react';
import DateDropDown from '../../operations/common/datedropdown';
import RefreshButton from '../../common/refreshbutton';
import history from '../../../history';

type TPayrollAdminFiltersProps = {
    onFilterChange: (id: string, value: any) => void;
    reloadData: () => void;
};

export default function PayrollAdminFilters({
    onFilterChange,
    reloadData,
}: TPayrollAdminFiltersProps) {
    return (
        <div className="table-filter-container payroll-filter-container">
            <DateDropDown
                onFilterChange={onFilterChange as any}
                history={history}
                mode="payroll"
            />
            <div className="table-action-bar">
                <RefreshButton reloadData={reloadData} />
            </div>
        </div>
    );
}
